export const GET_STUDENT_ALL_COURSES = "GET_STUDENT_ALL_COURSES"; 

export const GET_STUDENT_SCHEDULES = "GET_STUDENT_SCHEDULES";

export const GET_SINGLE_COURSE = "GET_SINGLE_COURSE"; 

export const RETRIEVE_STUDENT_DETAILS_CALENDAR = "RETRIEVE_STUDENT_DETAILS_CALENDAR"; 